/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelListGet } from '../fn/user-accessable-hotels-endpoint/api-hotel-list-get';
import { ApiHotelListGet$Params } from '../fn/user-accessable-hotels-endpoint/api-hotel-list-get';
import { HotelInfoArrayResultApiResult } from '../models/hotel-info-array-result-api-result';

@Injectable({ providedIn: 'root' })
export class UserAccessableHotelsEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelListGet()` */
  static readonly ApiHotelListGetPath = '/api/hotel/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHotelListGet$Response(params?: ApiHotelListGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HotelInfoArrayResultApiResult>> {
    return apiHotelListGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHotelListGet(params?: ApiHotelListGet$Params, context?: HttpContext): Observable<HotelInfoArrayResultApiResult> {
    return this.apiHotelListGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<HotelInfoArrayResultApiResult>): HotelInfoArrayResultApiResult => r.body)
    );
  }

}
